module.exports = __webpack_public_path__ + "img/服务热线@2x.6765b543.png";